import {useContext, useEffect} from "react";
import {useSelector} from "react-redux";
import {
    AccountService,
    PopupDto,
    PopupService,
    SurveyDto,
    SurveyService,
} from "../api/psc";
import {DialogContext} from "../contexts/DialogueContext";
import {IntegrationContext} from "../contexts/IntegrationContext";
import {UserContext} from "../contexts/UserContext";
import Popup from "../features/popup/Popup";
import CategorizationDialog from "../features/surveys/dialogs/CategorizationDialog";
import CustomerExperienceSurveyDialog from "../features/surveys/dialogs/CustomerExperienceSurveyDialog";
import {RootState} from "../slices/Store";
import {checkVersionAndUpdateIfNeeded} from "../utils/app";

export default function Requirements(props: {
    children: JSX.Element | JSX.Element[];
}) {
    const user = useContext(UserContext);
    const {openDialog} = useContext(DialogContext);
    const integration = useContext(IntegrationContext);

    const activityState = useSelector(
        (state: RootState) => state.activityState
    );

    useEffect(() => {
        integration.refreshBadgeCount();
    }, [
        activityState.reminderNotificationBadgeCount,
        activityState.taskNotificationBadgeCount,
    ]);

    useEffect(() => {
        if (user === null) {
            return;
        }
        const timer = setInterval(() => {
            processScaffoldRequirements().then();
        }, 60000);
        return () => {
            clearTimeout(timer);
        };
    }, [user]);

    useEffect(() => {
        if (user === null) {
            return;
        }
        const timer = setInterval(() => {
            checkVersionAndUpdateIfNeeded();
        }, 60000);
        return () => {
            clearTimeout(timer);
        };
    }, [user]);

    useEffect(() => {
        if (user !== null) {
            processScaffoldRequirements().then();
        }
    }, [user]);

    const processScaffoldRequirements = async () => {
        const popup = await getAvailablePopUp();
        const survey = await getPendingSurvey();
        const category = await getCategorizationPopUp();

        if (category) {
            openDialog(
                <CategorizationDialog key="CategorisationDialog"/>,
                () => {
                },
                false
            );
        } else if (popup) {
            openDialog(<Popup popup={popup} preview={false} key={popup.id}/>);
        } else if (survey) {
            openDialog(
                <CustomerExperienceSurveyDialog
                    id={survey.id}
                    key={survey.id}
                />
            );
        }
    };

    const getCategorizationPopUp = async (): Promise<boolean> => {
        try {
            return await AccountService.isCategorizationRequired("1");
        } catch (error) {
        }
    };

    const getAvailablePopUp = async (): Promise<PopupDto | undefined> => {
        return PopupService.getAvailablePopup("1");
    };

    const getPendingSurvey = async (): Promise<SurveyDto> => {
        return SurveyService.getPendingSurvey("1");
    };

    return <>{props.children}</>;
}
